<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'organization.detail'">
    @if (showBackButton()) {
      <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">{{
        'button.back' | transloco
      }}</htx-button>
    }

    <div class="panel">
      <!-- Pending Organization Banner -->
      @if (isOrganizationPending() && !isDataspaceAuthority) {
        <div class="pending-banner">
          <span class="material-icons">hourglass_empty</span>
          <div class="pending-banner-content">
            <span class="pending-banner-title">{{ t('pendingBanner.title') }}</span>
            <span class="pending-banner-text">{{ t('pendingBanner.text') }}</span>
          </div>
          <htx-button variant="secondary" icon="visibility" (click)="viewApprovalStatus()">
            {{ t('pendingBanner.viewStatus') }}
          </htx-button>
        </div>
      }

      <div class="header-section">
        <div class="header-title-section">
          <h1 class="header-title">{{ 'organization.detail.header' | transloco }}</h1>
          <p class="header-subtitle">{{ 'organization.detail.sub-header' | transloco }}</p>
        </div>
        <div class="header-actions">
          @if (canEditOrganizations) {
            <htx-button
              variant="tertiary"
              icon="edit"
              (click)="edit()"
              [disabled]="isOrganizationPending()"
              >{{ 'button.edit' | transloco }}</htx-button
            >
          }
          @if (isDataspaceAuthority && canSuspend()) {
            <htx-button variant="tertiary" icon="block" (click)="requestSuspend()">{{
              t('actions.suspend')
            }}</htx-button>
          }
          @if (isDataspaceAuthority && canReactivate()) {
            <htx-button variant="tertiary" icon="check_circle" (click)="requestReactivate()">{{
              t('actions.reactivate')
            }}</htx-button>
          }
          @if (isDataspaceAuthority) {
            <htx-button variant="tertiary" icon="delete" (click)="requestDelete()">{{
              t('actions.delete')
            }}</htx-button>
          }
        </div>
      </div>

      @let orgDetails = organisationDetails$ | async;
      <htx-data-display
        [title]="t('organisationDetails')"
        [icon]="'business'"
        [data]="orgDetails ?? []"
        [loading]="orgDetails === null"
      ></htx-data-display>

      <htx-data-container
        [title]="'organization.detail.organizationMembers' | transloco"
        icon="people"
      >
        @if (canAddMembers) {
          <div class="member-table-actions">
            <htx-button
              variant="primary"
              icon="person_add"
              (click)="addMember()"
              [disabled]="isOrganizationPending()"
              >{{ 'button.invite' | transloco }}</htx-button
            >
          </div>
        }
        @let memberData = member$ | async;
        <htx-table
          [data]="memberData ?? []"
          [loading]="memberData === null"
          [columns]="(columnConfig$ | async) || []"
        ></htx-table>
      </htx-data-container>
    </div>

    <!-- Confirmation Dialog Overlay -->
    @if (confirmDialogData()) {
      <div class="dialog-overlay">
        <app-confirm-dialog
          [data]="confirmDialogData()"
          (confirmed)="onConfirmDialogResult($event)"
        ></app-confirm-dialog>
      </div>
    }

    <!-- Confirmation Dialog with Reason Overlay -->
    @if (reasonDialogData()) {
      <div class="dialog-overlay">
        <htx-confirm-dialog-with-reason
          [data]="reasonDialogData()"
          (confirmed)="onReasonDialogResult($event)"
        ></htx-confirm-dialog-with-reason>
      </div>
    }
  </div>
</app-protected-content>

<ng-template #columnRoles let-row>
  @let member = getTyped(row);
  <div class="role-badges">
    @for (role of member.roles; track role) {
      <htx-badge
        [text]="'organization.member.roles.labels.' + role.toLowerCase() | transloco"
        variant="tertiary"
      ></htx-badge>
    }
  </div>
</ng-template>

<ng-template #columnActions let-row>
  @let member = getTyped(row);
  <div class="action-buttons">
    <htx-button
      variant="tertiary"
      icon="visibility"
      [iconOnly]="true"
      tooltip="Anzeigen"
      (click)="viewMember(member)"
    ></htx-button>
    <htx-button
      variant="tertiary"
      icon="edit"
      [iconOnly]="true"
      tooltip="Bearbeiten"
      [disabled]="isOrganizationPending()"
      (click)="editMember(member)"
    ></htx-button>
  </div>
</ng-template>
